const routes = {
  CONSULTATION: "/consultation-request",
  SERVERERROR: "/server-error",
  PROFILENOTFOUND:"/profile-not-found",
  UNDERCONSTRUCTION: "/under-construction",
  PREVIEW:"/",
  PREPAYMENT: "/pre-payment",
  TRANSACTION: "/transaction",
  ConfirmationStatements: "/confirmation-statements",
  DASHBOARD:"/dashboard",
  INSURANCEPOLICY: "/insurance-policy",


};

export default routes;
